import {MdOutlineMobileFriendly, MdKeyboardArrowRight} from 'react-icons/md';

import {Button} from '@jobseeker/lotus/elements';
import {Box} from '@jobseeker/lotus/foundations';
import Header from '@jobseeker/lotus/components/Header';
import {useIsLargeDevice, useWrappedTheme} from '@jobseeker/lotus/hooks';
import Search from '@jobseeker/feature-navigation/components/Search';
import type {Props} from '@jobseeker/lotus/components/Header/types';
import {useInterceptor} from '@jobseeker/common-core';
import {
  openUrl,
  deferTask,
  getUbaPageName,
  TrackEventUBA,
} from '@jobseeker/common-core/utils';

const HeaderWithBtn = (props: Props) => {
  const {
    config: {
      showSearchBar = true,
      showDownloadApp = false,
      showRecruiter = true,
    },
    OnSearchBtnClick,
  } = props || {};

  const theme = useWrappedTheme();
  const isLargeDevice = useIsLargeDevice();
  const {
    header: {
      meta: {
        downloadApp: {link: downloadAppLink},
        recruiter,
      },
    },
  } = useInterceptor();

  return (
    <Header {...props}>
      <Box sx={{display: 'flex', marginLeft: 'auto', alignItems: 'center'}}>
        {showSearchBar && (
          <Search
            onClick={(event: React.MouseEvent) => {
              TrackEventUBA('topMenuClick', 'click', {
                section: 'Other',
                page: getUbaPageName(),
                sessionUsername: sessionStorage.getItem('userId') || '',
                clickedMenuName: 'Search',
              });
              OnSearchBtnClick?.(event);
            }}
            theme={theme}
            isLargeDevice={isLargeDevice}
          />
        )}
        <Box sx={{display: {xxs: 'none', md: 'flex'}}}>
          {showDownloadApp && (
            <Button
              variant="outlined"
              label="download_app"
              size="large"
              href={downloadAppLink}
              target="_blank"
              sx={{
                // marginLeft: theme.spacing(6),
                borderRadius: theme.spacing(3),
              }}
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                TrackEventUBA('topMenuClick', 'click', {
                  section: 'Other',
                  page: getUbaPageName(),
                  sessionUsername: sessionStorage.getItem('userId') || '',
                  clickedMenuName: 'DownloadApp',
                });
                if (downloadAppLink) {
                  deferTask(() => {
                    openUrl(downloadAppLink, '_blank');
                  });
                }
              }}
            >
              <MdOutlineMobileFriendly
                fontSize={theme.typography.pxToRem(20)}
                style={{marginRight: theme.spacing(0.5)}}
              />
              Download App{' '}
              <MdKeyboardArrowRight fontSize={theme.typography.pxToRem(18)} />
            </Button>
          )}

          {showRecruiter && (
            <Button
              variant="outlined"
              label="recruiter_login"
              size="large"
              href={recruiter}
              target="_blank"
              sx={{
                marginLeft: theme.spacing(1),
                borderRadius: theme.spacing(3),
              }}
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                if (recruiter) {
                  deferTask(() => {
                    openUrl(recruiter, '_blank');
                  });
                }
              }}
            >
              Recruiter Login{' '}
            </Button>
          )}
        </Box>
        <Box
          sx={{
            display: {xxs: 'flex', md: 'none'},
            mr: 1,
          }}
        >
          {showRecruiter && (
            <Button
              variant="outlined"
              label="recruiter_login"
              size="small"
              href={recruiter}
              target="_blank"
              sx={{
                borderRadius: theme.spacing(3),
              }}
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                if (recruiter) {
                  deferTask(() => {
                    openUrl(recruiter, '_blank');
                  });
                }
              }}
            >
              Recruiter Login{' '}
            </Button>
          )}
        </Box>
      </Box>
    </Header>
  );
};

export default HeaderWithBtn;
